import React from 'react'
import ListItemContainer from './ListItemContainer'
import { motorShape } from '../../shapes'

const ListItem = props => <ListItemContainer {...props} />

ListItem.propTypes = {
  motor: motorShape.isRequired
}

export default ListItem
